import React from 'react';

import { colorsSelector } from '@redux/colorPalette/selectors';
import { deleteAllSongs } from '@redux/player';
import analytics from 'lib/analytics/analytics';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import ModalLayout from 'components/b2b/ModalLayout';
import { getSpacing } from 'stylesheetB2b';

import { Message, TrashIcon, Button } from './DeleteModal.style';

interface Props {
  onClose: () => void;
  isOpen: boolean;
}

const DeleteModal: React.FC<Props> = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const colors = useSelector(colorsSelector);
  const deleteAll = () => {
    dispatch(deleteAllSongs());
    analytics.track('waitingList_header_deleteAll_confirm');
    onClose();
  };
  const cancelDelete = () => {
    analytics.track('waitingList_header_deleteAll_cancel');
    onClose();
  };

  return (
    <ModalLayout isOpen={isOpen} onClose={onClose} hideBackdrop={false} width={getSpacing(81)}>
      <TrashIcon {...{ colors }} />
      <Message {...{ colors }}>
        <FormattedMessage id='waiting-list.delete-all-confirmation-message' />
      </Message>
      <Button
        translationId='waiting-list.delete-all-confirmation-no-button'
        onClick={cancelDelete}
        largeFont
      />
      <Button
        translationId='waiting-list.delete-all-confirmation-yes-button'
        onClick={deleteAll}
        error
        light
        largeFont
      />
    </ModalLayout>
  );
};

export default DeleteModal;
